import { Box, Flex, Icon, Table, Tbody, Text, Th, Thead, Td as ChakraTd, Tr as ChakraTr, TableContainer, Tooltip, Spinner } from '@chakra-ui/react'
import { Td, Tr } from '../../components/Table'
import { FaCheckCircle, FaWhatsapp } from 'react-icons/fa'
import { CustomTooltip } from '../../components/CustomTooltip'
import { Telefone } from '../../components/Telefone'
import { permissoesUsuariosPropostas } from '../../utils/permissoesUsuariosProposta'
import { user } from '../../helpers/user'
import { GiPin } from 'react-icons/gi'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../services/api'
import { useParams, useSearchParams } from 'react-router-dom'

async function fetchOnPin(parameters) {
  const response = await api.get(`/orcamento-pedido/fixar-proposta`, {
    params: parameters,
  })

  return response.data
}

async function fetchOnUnpin(parameters) {
  const response = await api.get('/orcamento-pedido/remover-fixar-proposta', {
    params: parameters,
  })

  return response.data
}

export function Item({ data, odd, params }) {
  const queryClient = useQueryClient()
  const [searchParams, setSearchParams] = useSearchParams()

  const { idVendedor } = useParams()

  function handleUnpinProposal(proposal) {
    const parameters = {
      numero_nota: proposal.nunota,
      numero_pedido: proposal.codigo_proposta,
    }
    onUnpin(parameters)
  }

  async function handlePinProposal(proposal) {
    const parameters = {
      numero_nota: proposal.nunota,
      numero_pedido: proposal.codigo_proposta,
    }

    await onPin(parameters)
  }

  const { mutateAsync: onPin, isLoadingPin } = useMutation({
    mutationFn: fetchOnPin,
    onSuccess: (sucessData) => {
      queryClient.setQueryData(
        [
          'propostas',
          {
            userCode: idVendedor,
            params,
          },
        ],
        (old) => {
          const newData = old.data
            .map((item) => {
              if (item.nunota === sucessData.numero_nota) {
                return {
                  ...item,
                  proposta_fixada: true,
                }
              }

              return item
            })
            .sort((a, b) => b.proposta_fixada - a.proposta_fixada)

          return {
            ...old,
            data: newData,
          }
        }
      )
    },

    // onError: (err, variables, context) => {
    //     queryClient.setQueryData('propostas', context.previousValue)
    // },
    // onSettled: () => {
    //     queryClient.invalidateQueries('propostas')
    // },
  })

  const { mutateAsync: onUnpin, isLoadingUnpin } = useMutation({
    mutationFn: fetchOnUnpin,
    onSuccess: (data) => {
      queryClient.setQueryData(
        [
          'propostas',
          {
            userCode: idVendedor,
            params,
          },
        ],
        (old) => {
          const newData = old.data
            .map((item) => {
              if (item.nunota === data.numero_nota) {
                return {
                  ...item,
                  proposta_fixada: false,
                }
              }

              return item
            })
            .sort((a, b) => b.proposta_fixada - a.proposta_fixada)

          return {
            ...old,
            data: newData,
          }
        }
      )
    },

    // onError: (err, variables, context) => {
    //     queryClient.setQueryData('propostas', context.previousValue)
    // },
    // onSettled: () => {
    //     queryClient.invalidateQueries('propostas')
    // },
  })

  return (
    <Tr border={data?.proposta_fixada ? '1px solid #FF8800' : 'none'}>
      <Td borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'} py={0}>
        <Flex flexDir="column">
          <Text
            as="a"
            href={`/vendas/orcamento-pedido/${data.nunota}`}
            target="_blank"
            color="#378BBF"
            textDecoration="underline"
            _hover={{ color: '#2D3748' }}
            _focus={{ color: '#2D3748' }}
          >
            {data.nunota}
          </Text>
          {data.abertura}
        </Flex>
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'} w="200px">
        <Flex gap={2} alignItems="center" position="relative">
          <Flex flexDirection="column" alignItems="center" w="100%">
            <Text as="a" href={data.link_proposta} target="_blank" textDecor="underline" color="#378BBF">
              {data.proposta}
            </Text>
            <CustomTooltip
              label={
                <Box h="16px" px={2} bgColor="#378BBF" display="flex" alignItems="center" justifyContent="center" fontSize="12px" color="white">
                  {data?.info_proposta?.length} itens
                </Box>
              }
              bg="#fff"
              color="black"
              fontSize="12px"
            >
              <TableContainer>
                <Table size="sm">
                  <Thead>
                    <ChakraTr>
                      <Th>Cod</Th>
                      <Th>Cor</Th>
                      <Th isNumeric>Qtd</Th>
                    </ChakraTr>
                  </Thead>
                  <Tbody>
                    {data?.info_proposta?.map((item, index) => (
                      <ChakraTr bgColor="white!important" fontSize="12px" fontWeight="normal" key={index}>
                        <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                          {item.codigo_produto}
                        </ChakraTd>
                        <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                          {item.cor}
                        </ChakraTd>
                        <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                          {item.quantidade_itens}
                        </ChakraTd>
                      </ChakraTr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </CustomTooltip>
          </Flex>
          {data?.pedido_especial === '1' && <Icon as={FaCheckCircle} color="#378BBF" fontSize="20px" top="50%" right="-1" />}
        </Flex>
      </Td>
      {/* 378BBF */}
      {permissoesUsuariosPropostas[user.codigo_usuario] && (
        <Td py={0} h="36px" borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
          {data.nome_vendedor}
        </Td>
      )}
      <Td py={0} h="36px" borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex justifyContent="center" alignItems="center" h="100%">
          {data?.desconto !== 'N' && <Icon as={FaCheckCircle} color="#76BF37" fontSize="20px" />}
        </Flex>
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex alignItems="center" justifyContent="space-between" gap={2} w="160px" mx="auto">
          <CustomTooltip
            label={
              <Text color="#1a202c" isTruncated textTransform={'capitalize'} textAlign="center" maxW="130px">
                {data?.cliente}
              </Text>
            }
            bg="#fff"
            fontSize="12px"
          >
            <TableContainer>
              <Table size="sm">
                <Thead>
                  <ChakraTr>
                    <Th>Cod</Th>
                    <Th>Nome</Th>
                    <Th isNumeric>Pedidos</Th>
                    <Th isNumeric>Valores</Th>
                  </ChakraTr>
                </Thead>
                <Tbody>
                  <ChakraTr bgColor="white!important" fontSize="12px" fontWeight="normal">
                    <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                      {data.codigo_parceiro}
                    </ChakraTd>
                    <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                      <Text color="#1a202c" textTransform={'capitalize'} textAlign="center">
                        {data?.cliente}
                      </Text>
                    </ChakraTd>
                    <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                      {data.contagem_pedidos}
                    </ChakraTd>
                    <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                      {data.valor_total_parceiro}
                    </ChakraTd>
                  </ChakraTr>
                </Tbody>
              </Table>
            </TableContainer>
          </CustomTooltip>
          {data?.cliente_especial === 'S' && <Icon as={FaCheckCircle} color="#FFA200" fontSize="20px" ml="auto" />}
        </Flex>
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        <Tooltip label={data.nome_contato} bg="#378BBF" color="white" fontSize="12px">
          <Text maxW="130px" isTruncated>
            {data.nome_contato}
          </Text>
        </Tooltip>
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.verba}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.valorProposta}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.prazo}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.dataPropostaEncaminhada}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex flexDirection="column" justifyContent="start" alignItems="center">
          {data.layoutEnviado}
          {data?.info_layout?.length > 0 && (
            <CustomTooltip
              label={
                <Box h="16px" px={2} bgColor="#378BBF" display="flex" alignItems="center" justifyContent="center" fontSize="12px" color="white">
                  {data?.info_layout?.length} layouts
                </Box>
              }
              bg="#fff"
              color="black"
              fontSize="12px"
            >
              <Table size="sm" bgColor="white!important">
                <Thead>
                  <ChakraTr>
                    <Th>Cod</Th>
                    <Th>Cor</Th>
                    <Th>Solicitado</Th>
                    <Th>Encaminhado ao Cliente</Th>
                  </ChakraTr>
                </Thead>
                <Tbody>
                  {data?.info_layout?.map((item, index) => (
                    <ChakraTr key={index}>
                      <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                        <Text as="a" target="_blank" textDecoration="underline" color="#378BBF" href={item.link_layout} cursor="pointer">
                          {item.codigo_produto}
                        </Text>
                      </ChakraTd>
                      <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                        {item.cor}
                      </ChakraTd>
                      <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                        <strong>{item.nome_usuario}</strong> {item.solicitacao}
                      </ChakraTd>
                      <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal" textAlign="center">
                        {item.encaminhado}
                      </ChakraTd>
                    </ChakraTr>
                  ))}
                </Tbody>
              </Table>
            </CustomTooltip>
          )}
        </Flex>
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.origem_contato}
      </Td>
      <Td py={1} textTransform="capitalize" borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'} position="relative">
        <Flex flexDir="column" alignItems="center">
          <Text w="100%" bgColor={data.lineColor} color="white">
            {data.funilVendas}
          </Text>
          <Text>{data.data_funil}</Text>
        </Flex>
      </Td>
      {searchParams.get('propostas_perdidas') === 's' && (
        <Td>
          <Tooltip
            label={data?.observacao}
            bg="#378BBF"
            color="white"
            fontSize="12px"
            placement="top"
            hasArrow
            arrowSize={10}
            borderRadius="4px"
            border="1px solid #378BBF"
            borderColor="#378BBF"
            padding={1}
            textAlign="center"
            textTransform="capitalize"
            isDisabled={!data?.observacao}
          >
            <Text maxW="130px" isTruncated>
              {data.observacao}
            </Text>
          </Tooltip>
        </Td>
      )}

      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.ultimoContato}
      </Td>
      <Td py={0} borderRight="1px solid #CFCFCF" bgColor={odd ? '#EDF2F7' : 'white'}>
        {data.retornarEm}
      </Td>
      <Td py={0} bgColor={odd ? '#EDF2F7' : 'white'}>
        <Flex gap={2} alignItems="center" justifyContent="space-between">
          <Box as={data?.link_whats ? 'a' : 'div'} href={data.link_whats} target="_blank">
            <Icon
              as={FaWhatsapp}
              color={data?.link_whats ? '#25D366' : 'red.500'}
              fontSize="20px"
              _hover={{
                cursor: 'pointer',
                transform: 'scale(1.1)',
              }}
              transition="all 0.2s"
            />
          </Box>
          <Telefone {...data} />
        </Flex>
      </Td>
      <Td py={0} bgColor={odd ? '#EDF2F7' : 'white'}>
        {data?.proposta_fixada ? (
          <Icon
            as={isLoadingPin ? <Spinner /> : GiPin}
            color="#FF8800"
            fontSize="25px"
            _hover={{
              cursor: 'pointer',
              transform: 'scale(1.1)',
            }}
            transition="all 0.2s"
            onClick={() => handleUnpinProposal(data)}
          />
        ) : (
          <Icon
            as={isLoadingUnpin ? <Spinner /> : GiPin}
            color="#CFCFCF"
            fontSize="25px"
            _hover={{
              cursor: 'pointer',
              transform: 'scale(1.1)',
            }}
            transition="all 0.2s"
            onClick={() => handlePinProposal(data)}
          />
        )}
      </Td>
    </Tr>
  )
}
